import { Checkbox } from 'ui/checkboxV2';
import { FormField } from 'ui/formField';
import { SystemWebhookFormState } from '../types';

export const FiltersFormField = ({
  updateWebhook,
  webhook,
}: {
  updateWebhook: (field: string, value: boolean) => void;
  webhook: SystemWebhookFormState;
}) => (
  <FormField
    data-test="form-field-excludeListUpdates"
    inputId="excludeListUpdates"
    labelText="Additional filtering"
  >
    <Checkbox
      id="excludeListUpdates"
      label="Exclude list update events"
      status={webhook.excludeListUpdates ?? false}
      setChecked={(checked: boolean | 'indeterminate') => {
        updateWebhook('excludeListUpdates', checked as boolean);
      }}
    ></Checkbox>
  </FormField>
);
